import { cn } from '@/lib/utils';
import {
  Activity,
  AlertTriangle,
  Archive,
  ArrowLeftRight,
  ArrowRightLeft,
  ArrowUpDown,
  BadgeInfo,
  Ban,
  Barcode,
  BookText,
  Brain,
  CableIcon,
  CalendarIcon,
  CaptionsIcon,
  CaptionsOff,
  CarIcon,
  Check,
  CheckCircle,
  CheckSquare,
  ChevronLeftIcon,
  ChevronsUpDown,
  Circle,
  CircleDashed,
  CircleSlash,
  CircleSmall,
  CircleUserRound,
  ClipboardList,
  Columns3,
  Columns4Icon,
  Delete,
  Ellipsis,
  ExternalLinkIcon,
  FileText,
  GavelIcon,
  HatGlasses,
  Inbox,
  Landmark,
  LayoutGridIcon,
  LinkIcon,
  ListChecks,
  ListEnd,
  ListFilter,
  ListIcon,
  ListMinus,
  ListXIcon,
  MessageSquare,
  MessageSquareX,
  Minus,
  Navigation,
  PanelLeft,
  PanelLeftClose,
  PaperclipIcon,
  Pause,
  PencilIcon,
  PenLine,
  PersonStanding,
  Play,
  Plus,
  PlusIcon,
  Route,
  Rows4Icon,
  ScanBarcode,
  ShoppingCart,
  SignalHigh,
  SignalLow,
  SignalMedium,
  SlidersHorizontalIcon,
  SmilePlus,
  Sparkles,
  SparklesIcon,
  SquareDot,
  SquareKanban,
  Trash2,
  Truck,
  TruckElectric,
  Undo2,
  Wrench,
  X,
} from 'lucide-react';

// IMPORTANT NOTE: Please use the PDK prefix for all icons
// This is to avoid naming collisions with the Lucide icons

export const PDKVehicleSwapIcon = ({ className }: { className?: string }) => {
  return (
    <ArrowRightLeft className={cn('h-3.5 w-3.5 cursor-pointer', className)} />
  );
};

export const PDKVehicleTradeInIcon = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <ArrowLeftRight className={cn('h-3.5 w-3.5 cursor-pointer', className)} />
  );
};

export const PDKInboxIcon = ({ className }: { className?: string }) => {
  return <Inbox className={cn('h-3.5 w-3.5 cursor-pointer', className)} />;
};

export const PDKCopilotIcon = ({ className }: { className?: string }) => {
  return <Route className={cn('h-4 w-4', className)} />;
};

export const PDKMyDealsIcon = ({ className }: { className?: string }) => {
  return <SquareDot className={cn('h-3.5 w-3.5 cursor-pointer', className)} />;
};

export const PDKMyDealsBoardIcon = ({ className }: { className?: string }) => {
  return (
    <SquareKanban className={cn('h-3.5 w-3.5 cursor-pointer', className)} />
  );
};

export const PDKDeliveryQueueIcon = ({ className }: { className?: string }) => {
  return <ListEnd className={cn('h-3.5 w-3.5 cursor-pointer', className)} />;
};

export const PDKDealsListIcon = ({ className }: { className?: string }) => {
  return <Rows4Icon className={cn('h-3.5 w-3.5 cursor-pointer', className)} />;
};

export const PDKDealsBoardIcon = ({ className }: { className?: string }) => {
  return <Columns3 className={cn('h-3.5 w-3.5 cursor-pointer', className)} />;
};

export const PDKStagesIcon = ({ className }: { className?: string }) => {
  return (
    <Columns4Icon className={cn('h-3.5 w-3.5 cursor-pointer', className)} />
  );
};

export const PDKLogbookIcon = ({ className }: { className?: string }) => {
  return <BookText className={cn('h-3.5 w-3.5 cursor-pointer', className)} />;
};

export const PDKLenderIcon = ({ className }: { className?: string }) => {
  return <Landmark className={cn('h-3.5 w-3.5 cursor-pointer', className)} />;
};

export const PDKRapidReconStepIcon = ({
  className,
}: {
  className?: string;
}) => {
  return <Wrench className={cn('h-3.5 w-3.5 cursor-pointer', className)} />;
};

export const PDKEmptyValueIcon = ({ className }: { className?: string }) => {
  return <Minus className={cn('h-3.5 w-3.5 cursor-pointer', className)} />;
};

export const PDKNoUserIcon = ({ className }: { className?: string }) => {
  return (
    <CircleDashed className={cn('h-3.5 w-3.5 cursor-pointer', className)} />
  );
};

export const PDKCDKIcon = ({
  className,
  onClick,
}: {
  className?: string;
  onClick?: () => void;
}) => {
  return (
    <div
      className={cn(
        'border border-black rounded-md w-fit text-center py-0.5 px-1 text-icon cursor-pointer',
        className,
      )}
      onClick={onClick}
    >
      CDK
    </div>
  );
};

export const PDKAddTradeInIcon = ({ className }: { className?: string }) => {
  return <Plus className={cn('h-3.5 w-3.5 cursor-pointer', className)} />;
};

export const PDKMenuIcon = ({ className }: { className?: string }) => {
  return <Ellipsis className={cn('h-3.5 w-3.5 cursor-pointer', className)} />;
};

export const PDKPriorityHighIcon = ({ className }: { className?: string }) => {
  return <SignalHigh className={cn('h-3.5 w-3.5 cursor-pointer', className)} />;
};

export const PDKPriorityMediumIcon = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <SignalMedium className={cn('h-3.5 w-3.5 cursor-pointer', className)} />
  );
};

export const PDKPriorityLowIcon = ({ className }: { className?: string }) => {
  return <SignalLow className={cn('h-3.5 w-3.5 cursor-pointer', className)} />;
};

export const PDKPriorityNoneIcon = ({ className }: { className?: string }) => {
  return <Minus className={cn('h-3.5 w-3.5 cursor-pointer', className)} />;
};

export const PDKPriorityIcon = ({ className }: { className?: string }) => {
  return (
    <PDKPriorityHighIcon
      className={cn('h-3.5 w-3.5 cursor-pointer', className)}
    />
  );
};

export const PDKDeliveryDateIcon = ({ className }: { className?: string }) => {
  return (
    <CalendarIcon className={cn('h-3.5 w-3.5 cursor-pointer', className)} />
  );
};

export const PDKNoIcon = ({ className }: { className?: string }) => {
  return <Ban className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKRemoveFromDeliveryQueueIcon = ({
  className,
}: {
  className?: string;
}) => {
  return <ListXIcon className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKTrash2Icon = ({
  className,
  ...rest
}: {
  className?: string;
  rest?: React.HTMLAttributes<SVGSVGElement>;
}) => {
  return <Trash2 className={cn('h-3.5 w-3.5', className)} {...rest} />;
};

export const PDKConnectAccountsIcon = ({
  className,
}: {
  className?: string;
}) => {
  return <CableIcon className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKProfileIcon = ({ className }: { className?: string }) => {
  return <CircleUserRound className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKEditIcon = ({ className }: { className?: string }) => {
  return <PencilIcon className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKAttachFileIcon = ({ className }: { className?: string }) => {
  return <PaperclipIcon className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKToastInfoBadgeIcon = ({
  className,
}: {
  className?: string;
}) => {
  return <BadgeInfo className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKBarcodeIcon = ({
  className,
  onClick,
}: {
  className?: string;
  onClick?: () => void;
}) => {
  return <Barcode className={cn('h-3.5 w-3.5', className)} onClick={onClick} />;
};

export const PDKDBBarcodeIcon = ({
  className,
  onClick,
}: {
  className?: string;
  onClick?: () => void;
}) => {
  return (
    <ScanBarcode className={cn('h-3.5 w-3.5', className)} onClick={onClick} />
  );
};

export const PDKExpandListIcon = ({
  className,
  onClick,
}: {
  className?: string;
  onClick?: () => void;
}) => {
  return (
    <ChevronsUpDown
      className={cn('h-3.5 w-3.5', className)}
      onClick={onClick}
    />
  );
};

export const PDKPerformanceDiagnosticsIcon = ({
  className,
}: {
  className?: string;
}) => {
  return <Activity className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKLinkIcon = ({ className }: { className?: string }) => {
  return <LinkIcon className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKOpenInNewTabIcon = ({ className }: { className?: string }) => {
  return <ExternalLinkIcon className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKSidebarToggleIcon = ({
  open,
  className,
}: {
  open: boolean;
  className?: string;
}) => {
  return open ? (
    <PanelLeftClose className={cn('h-3.5 w-3.5', className)} />
  ) : (
    <PanelLeft className={cn('h-3.5 w-3.5', className)} />
  );
};

export const PDKTradeInAppraisalsIcon = ({
  className,
}: {
  className?: string;
}) => {
  return <ArrowRightLeft className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKAddIcon = ({ className }: { className?: string }) => {
  return <PlusIcon className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKTitlePresentIcon = ({ className }: { className?: string }) => {
  return <CaptionsIcon className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKTitleNotPresentIcon = ({
  className,
}: {
  className?: string;
}) => {
  return <CaptionsOff className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKDisplayIcon = ({ className }: { className?: string }) => {
  return <SlidersHorizontalIcon className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKListViewIcon = ({ className }: { className?: string }) => {
  return <ListIcon className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKBoardViewIcon = ({ className }: { className?: string }) => {
  return <LayoutGridIcon className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKFilterIcon = ({ className }: { className?: string }) => {
  return <ListFilter className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKNavigateBackIcon = ({ className }: { className?: string }) => {
  return <ChevronLeftIcon className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKPickupIcon = ({ className }: { className?: string }) => {
  return <PersonStanding className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKLocalDeliveryIcon = ({ className }: { className?: string }) => {
  return <TruckElectric className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKLongHaulIcon = ({ className }: { className?: string }) => {
  return <Truck className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKExtendedIcon = ({ className }: { className?: string }) => {
  return <Truck className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKOpenNewTabIcon = ({ className }: { className?: string }) => {
  return <ExternalLinkIcon className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKEmojiReactIcon = ({ className }: { className?: string }) => {
  return <SmilePlus className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKAuctionIcon = ({ className }: { className?: string }) => {
  return <GavelIcon className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKMLIcon = ({ className }: { className?: string }) => {
  return <Brain className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKCheckoutIcon = ({ className }: { className?: string }) => {
  return <ShoppingCart className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKAIIcon = ({ className }: { className?: string }) => {
  return <SparklesIcon className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKConfirmationUncheckedIcon = ({
  className,
}: {
  className?: string;
}) => {
  return <Circle className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKConfirmationCheckedIcon = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <CheckCircle className={cn('h-3.5 w-3.5 text-green-500', className)} />
  );
};

export const PDKConfirmationByPaddockCheckedIcon = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <PDKConfirmationCheckedIcon
      className={cn('h-3.5 w-3.5 text-blue-300', className)}
    />
  );
};

export const PDKConfirmationDisabledIcon = ({
  className,
}: {
  className?: string;
}) => {
  return <CircleSlash className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKCloseIcon = ({ className }: { className?: string }) => {
  return <X className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKAlertTriangleIcon = ({ className }: { className?: string }) => {
  return <AlertTriangle className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKResumeIcon = ({ className }: { className?: string }) => {
  return <Play className={cn('h-3 w-3', className)} />;
};

export const PDKPauseIcon = ({ className }: { className?: string }) => {
  return <Pause className={cn('h-3 w-3', className)} />;
};

export const PDKAgentWatchIcon = ({ className }: { className?: string }) => {
  return <HatGlasses className={cn('h-4 w-4', className)} />;
};

export const PDKMessageIcon = ({ className }: { className?: string }) => {
  return <MessageSquare className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKMessageSquareXIcon = ({
  className,
}: {
  className?: string;
}) => {
  return <MessageSquareX className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKListMinusIcon = ({ className }: { className?: string }) => {
  return <ListMinus className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKDeleteIcon = ({ className }: { className?: string }) => {
  return <Delete className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKDraftingIcon = ({ className }: { className?: string }) => {
  return <PenLine className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKAppraisalsIcon = ({ className }: { className?: string }) => {
  return <ClipboardList className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKArchiveIcon = ({ className }: { className?: string }) => {
  return <Archive className={cn('h-3.5 w-3.5', className)} />;
};

export const PDKSFSVGIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={cn('h-5 w-5', className)}
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      viewBox="0 0 128 128"
    >
      <path
        d="M116.62 124.26H11.32c-4.15 0-7.52-3.37-7.52-7.52V11.44c0-4.15 3.37-7.52 7.52-7.52h105.3c4.15 0 7.52 3.37 7.52 7.52v105.3c.01 4.15-3.36 7.52-7.52 7.52z"
        style={{
          fill: '#aed0d7',
        }}
      />
      <path
        d="M116.62 124.26H11.32c-4.15 0-7.52-3.37-7.52-7.52V11.44c0-4.15 3.37-7.52 7.52-7.52h105.3c4.15 0 7.52 3.37 7.52 7.52v105.3c.01 4.15-3.36 7.52-7.52 7.52z"
        style={{
          fill: '#aed0d7',
        }}
      />
      <radialGradient
        id="a"
        cx={77.845}
        cy={113.186}
        r={101.845}
        gradientTransform="matrix(-.0349 -.9994 1.9051 -.0666 -135.07 198.516)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.553}
          style={{
            stopColor: '#92bdcc',
          }}
        />
        <stop
          offset={0.622}
          style={{
            stopColor: '#b9d5de',
          }}
        />
        <stop
          offset={0.732}
          style={{
            stopColor: '#fff',
          }}
        />
      </radialGradient>
      <path
        d="m3.82 46.32-.07 23.13 120.4-7.31.16-41.9s-5.59-4.5-14.28-1.86-10.4 7.91-10.4 7.91-8.65-2.84-17.69 1.09c-11.8 5.12-16.46 16.13-16.46 16.13s-11.79-4.04-25.14-3.88c-18.89.24-36.52 6.69-36.52 6.69z"
        style={{
          fill: 'url(#a)',
        }}
      />
      <radialGradient
        id="b"
        cx={66.473}
        cy={139.576}
        r={86.395}
        fx={63.684}
        fy={139.807}
        gradientTransform="matrix(.1098 -.994 1.9081 .2107 -207.15 176.232)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.593}
          style={{
            stopColor: '#a1c3ce',
          }}
        />
        <stop
          offset={0.61}
          style={{
            stopColor: '#a8c8d2',
          }}
        />
        <stop
          offset={0.708}
          style={{
            stopColor: '#cee0e5',
          }}
        />
        <stop
          offset={0.799}
          style={{
            stopColor: '#e9f1f3',
          }}
        />
        <stop
          offset={0.879}
          style={{
            stopColor: '#f9fbfc',
          }}
        />
        <stop
          offset={0.94}
          style={{
            stopColor: '#fff',
          }}
        />
      </radialGradient>
      <path
        d="M42.23 59.4s8.03-3.78 18.97-4.23c7-.29 15.32 2.33 15.32 2.33s6.86-3.79 24.37-2.63c17.51 1.17 23.26 4.83 23.26 4.83l.01 39.24L3.78 95.6l.02-36.5s9.99-2.18 22.68-1.75c9.91.35 15.75 2.05 15.75 2.05z"
        style={{
          fill: 'url(#b)',
        }}
      />
      <path
        d="M124.17 61.85c-.27-.13-6.63-3.13-10.93-5.94-3.82-2.49-11.73-8.67-21.46-17.89-7.92-7.51-14.52-18.57-14.8-19.04l2.06-1.22c.07.11 6.72 11.25 14.39 18.52 9.61 9.11 17.38 15.18 21.12 17.62 4.16 2.71 9.53 5.2 9.59 5.23l.03 2.72z"
        style={{
          fill: '#b11f2b',
        }}
      />
      <path
        d="m106.02 99.6-2-.02.28-51.19 2 .02z"
        style={{
          fill: '#b11f2b',
        }}
      />
      <path
        d="M86.55 63.41h52.27v2H86.55z"
        style={{
          fill: '#b11f2b',
        }}
        transform="rotate(-89.888 112.69 64.406)"
      />
      <path
        d="M110.04 67.81h20.36v2h-20.36z"
        style={{
          fill: '#b11f2b',
        }}
        transform="matrix(.00488 -1 1 .00488 50.829 188.69)"
      />
      <path
        d="M24.47 82.59h17.95v2H24.47z"
        style={{
          fill: '#b11f2b',
        }}
        transform="rotate(-88.825 33.442 83.586)"
      />
      <path
        d="M8.99 77.06h27.34v2H8.99z"
        style={{
          fill: '#b11f2b',
        }}
        transform="rotate(-88.825 22.659 78.055)"
      />
      <path
        d="m43.65 98.34-2-.02.37-44.91 2 .02zM53.78 104.01l-2-.02.18-39.61 2 .02zM61.01 37.55h2v69.59h-2z"
        style={{
          fill: '#b11f2b',
        }}
      />
      <path
        d="M69.26 51.32h2v49.87h-2z"
        style={{
          fill: '#b11f2b',
        }}
        transform="matrix(1 -.0026 .0026 1 -.198 .183)"
      />
      <path
        d="M124.18 48.83c-.06-.04-6.68-4.94-12.69-10.12-4.04-3.48-8.67-8.24-11.26-11.2-4.31-4.92-6.88-8.68-6.99-8.84l1.99-1.35c.03.04 2.6 3.81 6.81 8.61 2.54 2.89 7.07 7.56 11.02 10.96C119 42 124.14 45.76 124.2 45.8l-.02 3.03z"
        style={{
          fill: '#ff2d26',
        }}
      />
      <path
        d="M78.43 17.02s4.7-.13 4.73-.04c.12.43.18 78.52.18 78.52l-7.91 3.21 3-81.69zM93.41 17.13s4.13-.07 4.21 0c.42.32.28 25.22.28 25.22h.83v55.54l-4.91-5.19-.41-75.57z"
        style={{
          fill: '#b01522',
        }}
      />
      <path
        d="M95.86 42.53h-1.39l-.04-25.41-4.23-.06-.02 2.78s-1.58 1.59-5.01 1.69c-3.43.09-4.82-2.13-4.82-2.13l-.03-2.4-5.16.04-.06 25.49-.98.06.05 7.27V92.7l.09 16.68 6.4-4.91-.09-33.74 9.09-.09v31.16l6.21.28V42.53zM80.29 29c.19-.37 9.74-.09 9.74-.09l-.09 13.63H80.3V29zm9.64 34.21h-9.64V49.86h9.64v13.35z"
        style={{
          fill: '#ff2d26',
        }}
      />
      <path
        d="M95 17.09s.32-3.23-1.65-3.2c-1.83.02-1.45 3.24-1.45 3.24s.78.02 1.66 0c1-.02 1.44-.04 1.44-.04zM79.48 13.84c-1.78.02-1.49 3.22-1.49 3.22s.81-.02 1.58-.02c.76 0 1.49-.04 1.49-.04s.32-3.18-1.58-3.16z"
        style={{
          fill: '#dd0c29',
        }}
      />
      <path
        d="m3.78 84.4.03-2.53c.06-.01 8.82-1.45 11.5-2.34.31-.1.84-.25 1.55-.46 5.79-1.65 23.41-6.67 43.05-20.31 21.63-15.02 31.07-40.17 31.17-40.42l2.25.83c-.09.26-9.78 26.1-32.05 41.57C41.31 74.6 23.4 79.7 17.51 81.37c-.67.19-1.15.33-1.45.43-2.83.95-12.03 2.55-12.28 2.6z"
        style={{
          fill: '#ff2d26',
        }}
      />
      <path
        d="M3.76 70.86v-2.35c.17 0 15.7-.17 39.12-16.72 8.67-6.12 20.59-16.75 25.52-22.74 5.64-6.86 5.89-8.53 6.64-10.27 0 0 .31-1.55 1.17-1.74.21-.05 1.71-.03 1.71-.03-.16.55-1.8 6.43-7.66 13.56-5.03 6.12-17.18 16.96-25.98 23.18C20.16 70.79 4.49 70.86 3.76 70.86z"
        style={{
          fill: '#b11f2b',
        }}
      />
      <radialGradient
        id="c"
        cx={68.785}
        cy={149.252}
        r={135.89}
        gradientTransform="matrix(-.00766 -1 2.0753 -.0159 -240.431 220.408)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.131}
          style={{
            stopColor: '#fff',
          }}
        />
        <stop
          offset={0.848}
          style={{
            stopColor: '#fff',
            stopOpacity: 0,
          }}
        />
      </radialGradient>
      <path
        d="M116.62 124.26H11.32c-4.15 0-7.52-3.37-7.52-7.52V11.44c0-4.15 3.37-7.52 7.52-7.52h105.3c4.15 0 7.52 3.37 7.52 7.52v105.3c.01 4.15-3.36 7.52-7.52 7.52z"
        style={{
          fill: 'url(#c)',
        }}
      />
      <radialGradient
        id="d"
        cx={17.72}
        cy={130.794}
        r={81.635}
        gradientTransform="matrix(.164 -.9865 1.3475 .224 -161.436 118.976)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.158}
          style={{
            stopColor: '#c0d0d5',
          }}
        />
        <stop
          offset={0.578}
          style={{
            stopColor: '#fafbfb',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fafbfb',
            stopOpacity: 0,
          }}
        />
      </radialGradient>
      <path
        d="M99.52 124.26h-88.2c-4.15 0-7.52-3.37-7.52-7.52l-.04-40.41s6.22-3.77 16.68-.83c10.46 2.93 16.51 12.1 16.51 12.1s7.03-5.97 18.71-3.12c15.05 3.67 23.49 22.2 23.49 22.2l20.37 17.58z"
        style={{
          fill: 'url(#d)',
        }}
      />
      <radialGradient
        id="e"
        cx={70.553}
        cy={51.231}
        r={79.852}
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.052}
          style={{
            stopColor: '#fafbfb',
            stopOpacity: 0,
          }}
        />
        <stop
          offset={0.571}
          style={{
            stopColor: '#fafbfb',
          }}
        />
        <stop
          offset={0.718}
          style={{
            stopColor: '#eef2f3',
          }}
        />
        <stop
          offset={0.919}
          style={{
            stopColor: '#d6e1e3',
          }}
        />
      </radialGradient>
      <path
        d="M124.15 73.21v43.53c0 4.15-3.37 7.52-7.52 7.52h-83.5s4.13-16.53 20.28-26.29c14.17-8.57 24.27-5.42 24.27-5.42s9.43-16.02 24.04-20.03 22.43.69 22.43.69z"
        style={{
          fill: 'url(#e)',
        }}
      />
    </svg>
  );
};

export const PDKTasksIcon = ({ className }: { className?: string }) => {
  return <CheckSquare className={cn('h-4 w-4', className)} />;
};

export const PDKAllTasksIcon = ({ className }: { className?: string }) => {
  return <ListChecks className={cn('h-4 w-4', className)} />;
};

export const PDKAiSparkle = ({ className }: { className?: string }) => {
  return <Sparkles className={cn('h-4 w-4', className)} />;
};

export const PDKCheck = ({ className }: { className?: string }) => {
  return <Check className={cn('h-4 w-4', className)} />;
};

export const PDKUndo = ({ className }: { className?: string }) => {
  return <Undo2 className={cn('h-4 w-4', className)} />;
};

export const PDKShowReasoning = ({ className }: { className?: string }) => {
  return <FileText className={cn('h-4 w-4', className)} />;
};

export const PDKCircleSmall = ({ className }: { className?: string }) => {
  return <CircleSmall className={cn('h-4 w-4', className)} />;
};

export const PDKArrowUpDown = ({ className }: { className?: string }) => {
  return <ArrowUpDown className={cn('h-4 w-4', className)} />;
};

export const PDKDealTaskIcon = ({ className }: { className?: string }) => {
  return <CarIcon className={cn('h-4 w-4', className)} />;
};

export const PDKDeliveryStageIcon = ({ className }: { className?: string }) => {
  return <Navigation className={cn('h-4 w-4', className)} />;
};
